import { BUILD, fmtBuildTime } from "@/config/build";
import { useAuth } from "@/context/AuthContext";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Sprout } from "lucide-react";
import { ABOUT } from "@/constants/testIds";

export function AboutDialog({ open, onOpenChange }) {
  const { tenant } = useAuth();
  const rows = [
    { label: "Application", value: "ROOTS Framework by SusTek" },
    { label: "Workspace", value: tenant?.name || "—" },
    { label: "Build", value: BUILD.number, testid: ABOUT.build },
    { label: "Version", value: `v${BUILD.major}.${BUILD.minor}`, testid: ABOUT.version },
    { label: "Published", value: fmtBuildTime(BUILD.publishedAt) },
    { label: "Environment", value: BUILD.env, testid: ABOUT.env },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid={ABOUT.dialog}>
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-sage-accent">
              <Sprout className="h-6 w-6 text-white" />
            </div>
            <div className="text-left">
              <DialogTitle className="font-heading">About ROOTS</DialogTitle>
              <DialogDescription>Build &amp; release information</DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <div className="divide-y rounded-lg border">
          {rows.map((r) => (
            <div key={r.label} className="flex items-center justify-between gap-4 px-3 py-2.5 text-sm">
              <span className="text-muted-foreground">{r.label}</span>
              <span className="text-right font-medium text-forest-dark" data-testid={r.testid}>{r.value}</span>
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-muted-foreground">
          Copyright © SusTek Pte Ltd. All Rights Reserved.
        </p>
      </DialogContent>
    </Dialog>
  );
}
